/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { FC, useCallback, useEffect, useState } from "react";
import { AgentData } from "../../store/api/model/AgentData";
import Tile from "../tiles/Tile";

import "../../App.css";

import { useMsal } from "@azure/msal-react";
import {
  faClone,
  faExclamationTriangle,
  faExternalLink,
  faMapLocation,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import FavoritenListe from "../favourites/FavoritenListe";
import { useFavorites } from "../favourites/FavoritesContext";
import FloatingHeadline from "../global/headlines/FloatingHeadline";
import CreateRequestTicketAction from "./CreateRequestTicketAction";
import CreateUserAction from "./CreateUserAction";
// import SpecialModalAd from "../SpecialModalAd";

// -----------------------------------------------------------------------------
// Types & Interfaces
// -----------------------------------------------------------------------------

interface CopyAddressComponentProps {
  name: string;
}

interface TileData {
  uuid: string;
  name: string;
  href: string;
  logoSrc: string;
  isNew?: boolean;
  requestActionName?: string;
  category: string;
  badgeText?: string;
  badgeType?: "warning" | "info" | "error";
}

export interface AgentsListProps {
  entries?: AgentData[];
}

// -----------------------------------------------------------------------------
// Environment / Config
// -----------------------------------------------------------------------------

const lambdaDataSecret: string = process.env.REACT_APP_LAMBDA_DATA_SECRET as string;
const lambdaDataUrl: string = process.env.REACT_APP_LAMBDA_DATA_URL as string;

// -----------------------------------------------------------------------------
// Client cache (instant load when available, survives refresh)
// -----------------------------------------------------------------------------

const TILES_CACHE_KEY = "auth-portal:tiles-data";
const TILES_CACHE_TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

let memoryCache: { data: TileData[]; ts: number } | null = null;

function getCachedTiles(): TileData[] | null {
  const now = Date.now();
  if (memoryCache && now - memoryCache.ts < TILES_CACHE_TTL_MS) return memoryCache.data;
  try {
    const raw = localStorage.getItem(TILES_CACHE_KEY);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw) as { data: TileData[]; ts: number };
    if (now - ts >= TILES_CACHE_TTL_MS) return null;
    memoryCache = { data, ts };
    return data;
  } catch {
    return null;
  }
}

function setCachedTiles(data: TileData[]): void {
  const ts = Date.now();
  memoryCache = { data, ts };
  try {
    localStorage.setItem(TILES_CACHE_KEY, JSON.stringify({ data, ts }));
  } catch {
    // ignore quota / private mode
  }
}

// -----------------------------------------------------------------------------
// Helper: FETCH WITH RETRY + TIMEOUT (Lambda cold start can take 10–15s)
// -----------------------------------------------------------------------------

const FETCH_TIMEOUT_MS = 18_000; // single attempt; cold start needs time

/**
 * Fetches JSON with timeout and retries (for Lambda cold starts).
 */
async function fetchWithRetry(url: string, retries = 3, backoff = 1_000): Promise<TileData[]> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
  try {
    const response = await fetch(url, { signal: controller.signal, cache: "no-store" });
    clearTimeout(timeoutId);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return (await response.json()) as TileData[];
  } catch (error) {
    clearTimeout(timeoutId);
    if (retries > 0) {
      await new Promise(res => setTimeout(res, backoff));
      return fetchWithRetry(url, retries - 1, backoff * 2);
    }
    throw error;
  }
}

// -----------------------------------------------------------------------------
// Sub‑components
// -----------------------------------------------------------------------------

const CopyAddressComponent: FC<CopyAddressComponentProps> = ({ name }) => {
  const [copySuccess, setCopySuccess] = useState("");
  const { t } = useTranslation();

  const address = `Thinkport GmbH\n${name}\nArnsburger Straße 74\n60385 Frankfurt (Main)`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopySuccess(t("copySuccess"));
    } catch {
      setCopySuccess(t("copyError"));
    }
  };

  return (
    <div className="text-center">
      <button className="px-4 py-2 m-2 bg-blue-500" data-tip={t("copyHint")} onClick={copyToClipboard}>
        <FontAwesomeIcon icon={faClone} />
      </button>

      {copySuccess && (
        <p className="bg-green-200 shadow-sm rounded-sm text-green-700 p-1" role="alert">
          {copySuccess}
        </p>
      )}
    </div>
  );
};

CopyAddressComponent.propTypes = {
  name: PropTypes.string.isRequired,
};

function AddressComponent() {
  const { t } = useTranslation();
  const [content, setContent] = useState("Xaddresses");

  useEffect(() => {
    const sections: Record<string, HTMLElement | null> = {
      Xaddresses: document.getElementById("Xaddresses"),
      postadressen: document.getElementById("postadressen"),
      invoiceadressen: document.getElementById("invoiceadressen"),
    };

    Object.keys(sections).forEach(key => {
      const el = sections[key];
      if (el) el.style.display = content === key ? "block" : "none";
    });
  }, [content]);

  const tabs = [
    { id: "Xaddresses", label: t("generalAdresses") },
    { id: "postadressen", label: t("sendingAdresses") },
    { id: "invoiceadressen", label: t("invoiecAdress") },
  ];

  return (
    <div className="flex justify-center">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab btn btn-xs new-border-radius text-white mr-3 ${
            content === tab.id ? "bg-primary" : "bg-black hover:bg-primary"
          }`}
          onClick={() => setContent(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

// -----------------------------------------------------------------------------
// Main component
// -----------------------------------------------------------------------------

export default function AgentsList({ entries }: AgentsListProps): JSX.Element {
  const [tilesData, setTilesData] = useState<TileData[]>(() => getCachedTiles() ?? []);
  const [isLoading, setIsLoading] = useState(() => !getCachedTiles()?.length);
  const [isError, setIsError] = useState<Error | null>(null);

  const { ids } = useFavorites();
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  const userName = accounts[0]?.name ?? "";
  const userEmail = accounts[0]?.username ?? "";
  const { t } = useTranslation();

  const categories = {
    support: (tile: TileData) => tile.category === "support",
    recently: (tile: TileData) => tile.category === "recently",
    collaboration: (tile: TileData) => tile.category === "collaboration",
    bookings: (tile: TileData) => tile.category === "bookings",
    benefits: (tile: TileData) => tile.category === "benefits",
  } as const;

  const getRandomCount = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1)) + min;

  // ---------------------------------------------------------------------------
  // Data loading & retry logic
  // ---------------------------------------------------------------------------

  const loadTiles = useCallback(async () => {
    setIsError(null);
    const cached = getCachedTiles();
    if (cached?.length) {
      setTilesData(cached);
      setIsLoading(false);
      // Revalidate in background (stale-while-revalidate)
      try {
        const fresh = await fetchWithRetry(`${lambdaDataUrl}?password=${lambdaDataSecret}`, 2, 1_500);
        setCachedTiles(fresh);
        setTilesData(fresh);
      } catch {
        // keep showing cached data
      }
      return;
    }
    setIsLoading(true);
    try {
      const data = await fetchWithRetry(`${lambdaDataUrl}?password=${lambdaDataSecret}`, 3, 1_000);
      setCachedTiles(data);
      setTilesData(data);
    } catch (err) {
      setIsError(err as Error);
      console.error("Fehler beim Laden der Daten:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadTiles();
  }, [loadTiles]);

  // ---------------------------------------------------------------------------
  // UI helpers
  // ---------------------------------------------------------------------------

  const SkeletonTile = () => (
    <div className="max-w card-border-lg overflow-hidden card-bg-color p-6 flex flex-col items-center justify-center animate-pulse">
      <div className="rounded-full bg-gray-300" style={{ width: "100px", height: "100px" }}></div>
      <span className="mt-2 inline-block bg-gray-300" style={{ width: "60px", height: "20px" }}></span>
    </div>
  );

  const Section = ({
    id,
    titleKey,
    tilesFilter,
  }: {
    id: string;
    titleKey: string;
    tilesFilter: (t: TileData) => boolean;
  }) => (
    <>
      <h1 id={id} className="text-5xl mt-8 mb-2 font-bold leading-none text-center">
        <FloatingHeadline>{t(titleKey)}</FloatingHeadline>
      </h1>
      {isError && (
        <div className="mt-4 flex justify-center">
          <div className="alert alert-error font-bold">
            <FontAwesomeIcon className="text-warning" icon={faExclamationTriangle} /> {t("fetchError")}
          </div>
        </div>
      )}
      <div className="grid lg:grid-cols-5 md:grid-cols-2 sm:grid-cols-1 gap-4">
        {isLoading
          ? Array.from({ length: getRandomCount(2, 5) }).map((_, i) => <SkeletonTile key={i} />)
          : tilesData
              .filter(tilesFilter)
              .map(tile => (
                <Tile
                  uuid={tile.uuid}
                  key={tile.uuid}
                  href={tile.href}
                  logoSrc={tile.logoSrc}
                  isNew={tile.isNew}
                  requestActionName={tile.requestActionName}
                  badgeText={tile.badgeText}
                  badgeType={tile.badgeType}
                />
              ))}
      </div>
    </>
  );

  // No agent entries found
  if (entries?.length === 0) {
    return (
      <div className="mt-5">
        <h3>{t("noResults")}</h3>
      </div>
    );
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------

  return (
    <div className="pt-4 pb-10 px-10">
      {/* Retry button (only visible when error) */}
      {isError && (
        <div className="flex justify-center mb-4">
          <button className="btn btn-sm" onClick={loadTiles}>
            <FontAwesomeIcon icon={faRotateRight} className="mr-2" />
            {t("retry")}
          </button>
        </div>
      )}

      {/* <SpecialModalAd delay={5000} reappearHours={3} imageSrc="..." /> */}

      {/* Confluence KI-Bot: erstmal ausgeblendet */}
      {false && (
        <div style={{ marginBottom: "5em" }}>
          <CreateUserAction />
        </div>
      )}

      {/* Theme warning
      <div role="alert" className="alert alert-warning mt-8 text-xl">
        <FontAwesomeIcon className="text-error" icon={faInfoCircle} />
        <span className="font-bold">{t("themeWarning")}</span>
      </div> */}

      {/* Favourites */}
      {ids.length > 0 && (
        <>
          <h1 id="favourites" className="text-5xl mt-6 font-bold leading-none text-center">
            <FloatingHeadline>{t("favourites")}</FloatingHeadline>
          </h1>
          {isLoading ? (
            <div className="grid lg:grid-cols-5 md:grid-cols-2 sm:grid-cols-1 gap-4 mb-6">
              {Array.from({ length: getRandomCount(2, 5) }).map((_, i) => (
                <SkeletonTile key={i} />
              ))}
            </div>
          ) : (
            <FavoritenListe tilesData={tilesData} />
          )}
        </>
      )}

      {/* Support, Recently, Addresses, Collaboration, Bookings, Benefits */}
      <Section id="support" titleKey="support" tilesFilter={categories.support} />
      <Section id="recently" titleKey="recently" tilesFilter={categories.recently} />

      {/* Addresses block (kept 1:1 from original for brevity) */}
      <h1 id="addresses" className="text-5xl mt-8 mb-2 font-bold leading-none text-center">
        <FloatingHeadline>{t("addresses")}</FloatingHeadline>
      </h1>
      {isLoading ? (
        <div className="grid lg:grid-cols-5 md:grid-cols-2 sm:grid-cols-1 gap-4">
          {Array.from({ length: getRandomCount(2, 5) }).map((_, i) => (
            <SkeletonTile key={i} />
          ))}
        </div>
      ) : (
        <>
          <AddressComponent />
          <br />
          <span id="Xaddresses">
            <div className="grid grid-cols-4 gap-4">
              <div className="card max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 flex items-center justify-center">
                <figure className="card-figure">
                  <img
                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    src="https://media.istockphoto.com/id/186367581/photo/frankfurt-germany.jpg?s=612x612&w=0&k=20&c=88fRkMlLA8pRWnfagc4OBY3GXAIKeaQFiTA9zN0Dr1k="
                    alt="Frankfurt"
                  />
                </figure>
                <div className="card-body">
                  <h1 className="card-title justify-center">
                    <div className="badge badge-xl">
                      <a href="https://www.google.com/maps/place/Arnsburger+Str.+74,+60385+Frankfurt+am+Main/@50.125182,8.7046104,17z/data=!3m1!4b1!4m6!3m5!1s0x47bd0eecb563bf17:0x18c811748aafac46!8m2!3d50.1251786!4d8.7067991!16s%2Fg%2F11bw403lcl">
                        FRANKFURT <FontAwesomeIcon icon={faMapLocation} />
                      </a>
                    </div>
                  </h1>
                  <p className="text-center">
                    Thinkport Headquarter
                    <br /> Arnsburger Straße 74 (Hinterhaus) <br /> 60385 Frankfurt (Main)
                  </p>
                  <p className="text-center mt-2">
                    <b>Ansprechpartner:&nbsp;</b>
                    <a className="hover:cursor-pointer hover:text-green-500" href="mailto:jbabutzka@thinkport.digital">
                      Joshuar Babutzka
                    </a>
                  </p>
                  <div className="card-actions justify-center">
                    <a
                      href="https://thinkport-digital.atlassian.net/wiki/spaces/COM/pages/2825420813/Zugang+und+Schl+ssel"
                      className="tab btn btn-xs btn-docs-access hover:shadow-lg mr-3 items-center"
                    >
                      Dokumentation für Zugang &nbsp; <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                    <CreateRequestTicketAction email={userEmail} platform="Nuki + SwitchBot" />
                  </div>
                </div>
              </div>

              <div className="card max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 flex items-center justify-center">
                <figure className="card-figure">
                  <img
                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    src="https://assets.adac.de/image/upload/ar_16:9,c_fill,f_auto,g_auto,q_auto:eco,w_1500/v1/ADAC-eV/KOR/Bilder/PR/sehenswuerdigkeiten-leipzig-skyline-2203_vslokk.jpeg"
                    alt="Leipzig"
                  />
                </figure>
                <div className="indicator">
                  <span className="indicator-item badge badge-warning font-bold">Neue Adresse seit 01.07.2026</span>
                </div>
                <div className="card-body">
                  <h1 className="card-title justify-center">
                    <div className="badge badge-xl">
                      <a href="https://www.google.de/maps/place/SimpliOffice+Coworking+Space+%26+Eventlocation+Leipzig/@51.3368225,12.3718825,16z/data=!3m2!4b1!5s0x47a7acea9db0dd55:0xe17a9406b0a79c63!4m6!3m5!1s0x47a6f9cd49586985:0xa208624a9bd59bee!8m2!3d51.3368225!4d12.3744574!16s%2Fg%2F11gjs9l5_l?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoASAFQAw%3D%3D">
                        LEIPZIG <FontAwesomeIcon icon={faMapLocation} />
                      </a>
                    </div>
                  </h1>
                  <p className="text-center">
                    Scaling Spaces NEO Leipzig
                    <br /> Petersstraße 33 <br /> 04109 Leipzig
                  </p>

                  <p className="text-center mt-2">
                    <b>Ansprechpartner:&nbsp;</b>
                    <a className="hover:cursor-pointer hover:text-green-500" href="mailto:cfriede@thinkport.digital">
                      Chrstina Friede
                    </a>
                  </p>
                  <div className="card-actions justify-center">
                    <a
                      href="https://thinkport-digital.atlassian.net/wiki/spaces/COM/pages/2328657938/How+to...+Basislager#Keys"
                      className="tab btn btn-xs btn-docs-access hover:shadow-lg mr-3 items-center"
                    >
                      Dokumentation für Zugang &nbsp; <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                  </div>
                </div>
              </div>

              <div className="card max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 flex items-center justify-center">
                <figure className="card-figure">
                  <img
                    src="https://d3c80vss50ue25.cloudfront.net/media/filer_public_thumbnails/filer_public/10/e3/10e3c6cc-819f-4827-90c5-a0a7bb31fa2e/220311_elbphilharmonie_c_thies_raetzke.jpg__686x387_q85_crop_subject_location-960%2C640_subsampling-2_upscale.jpg"
                    alt="Hamburg"
                  />
                </figure>
                <div className="indicator">
                  <span className="indicator-item badge badge-info font-bold">Noch bis 30.09.2026</span>
                </div>
                <div className="card-body">
                  <h1 className="card-title justify-center">
                    <div className="badge badge-xl">
                      <a href="https://www.google.com/maps/place/Arnsburger+Str.+74,+60385+Frankfurt+am+Main/@50.125182,8.7046104,17z/data=!3m1!4b1!4m6!3m5!1s0x47bd0eecb563bf17:0x18c811748aafac46!8m2!3d50.1251786!4d8.7067991!16s%2Fg%2F11bw403lcl">
                        HAMBURG <FontAwesomeIcon icon={faMapLocation} />
                      </a>
                    </div>
                  </h1>
                  <p className="text-center">
                    Unicorn Workspaces Sprinkenhof
                    <br /> Burchardstraße 14
                    <br /> 20095 Hamburg
                  </p>
                  <p className="text-center mt-2">
                    <b>Ansprechpartner:&nbsp;</b>
                    <a className="hover:cursor-pointer hover:text-green-500" href="mailto:crau@thinkport.digital">
                      Clemens Rau
                    </a>
                  </p>
                  <div className="card-actions justify-center">
                    <a
                      href="https://thinkport-digital.atlassian.net/wiki/spaces/COM/pages/2518056972/Hamburg#T%C3%BCr-%C3%B6ffnen-via-App"
                      className="tab btn btn-xs btn-docs-access hover:shadow-lg mr-3 items-center"
                    >
                      Dokumentation für Zugang &nbsp; <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                  </div>
                </div>
              </div>

              <div className="card max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 flex items-center justify-center">
                <figure className="card-figure">
                  <img
                    src="https://www.arcotel.com/files-sbbasic/sr_arcotel-group/berliner-fernsehturm.jpeg?w=720&h=720"
                    alt="Berlin"
                  />
                </figure>
                <div className="indicator">
                  <span className="indicator-item badge badge-info font-bold">{t("berlinOfficeSearch")}</span>
                </div>
                <div className="card-body">
                  <h1 className="card-title justify-center">
                    <div className="badge badge-xl">
                      <a href="https://www.google.com/maps/place/Kurfürstendamm+15,+10719+Berlin/@52.509648,13.398628,17z/data=!3m1!4b1!4m6!3m5!1s0x47a851c8b1b1b1b1:0x1a2b3c4d5e6f7g8h!8m2!3d52.509648!4d13.4008167!16s%2Fg%2F11bw403lcl">
                        BERLIN <FontAwesomeIcon icon={faMapLocation} />
                      </a>
                    </div>
                  </h1>
                  <p className="text-center">
                    Satellite Office KUD15 Gloria Berlin
                    <br /> Kurfürstendamm 15 <br /> 10719 Berlin
                    <br />
                    <span className="text-sm font-semibold opacity-90">{t("berlinOfficeSearch")}</span>
                  </p>
                  <p className="text-center mt-2">
                    <b>Ansprechpartner:&nbsp;</b>
                    <a
                      className="hover:cursor-pointer hover:text-green-500"
                      href="mailto:aengelhardt@thinkport.digital"
                    >
                      Andreas Engelhardt
                    </a>
                  </p>
                  <div className="card-actions justify-center">
                    <a
                      href="https://thinkport-digital.atlassian.net/wiki/x/BgBfsQ"
                      className="tab btn btn-xs btn-docs-access hover:shadow-lg mr-3 items-center"
                    >
                      Dokumentation für Zugang &nbsp; <FontAwesomeIcon icon={faExternalLink} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span id="postadressen">
            <div className="grid grid-cols-4 gap-4  in-card-text">
              <div className="max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 hover:cursor-pointer flex items-center justify-center">
                <div className="max-w-sm">
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase hover:cursor-pointer hover:text-green-500">
                    <a href="https://www.google.com/maps/place/Arnsburger+Str.+74,+60385+Frankfurt+am+Main/@50.125182,8.7046104,17z/data=!3m1!4b1!4m6!3m5!1s0x47bd0eecb563bf17:0x18c811748aafac46!8m2!3d50.1251786!4d8.7067991!16s%2Fg%2F11bw403lcl">
                      Frankfurt <FontAwesomeIcon icon={faMapLocation} />
                    </a>
                  </p>
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase"></p>
                  <div className="mt-6">
                    <p className="text-center">
                      {userName} <br />
                      c/o Thinkport GmbH
                      <br /> Arnsburger Straße 74 <br /> 60385 Frankfurt (Main)
                    </p>
                  </div>
                </div>
              </div>
              <div className="max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 hover:cursor-pointer flex items-center justify-center">
                <div className="max-w-sm">
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase hover:cursor-pointer hover:text-green-500">
                    <a href="https://www.google.de/maps/place/SimpliOffice+Coworking+Space+%26+Eventlocation+Leipzig/@51.3368225,12.3718825,16z/data=!3m2!4b1!5s0x47a7acea9db0dd55:0xe17a9406b0a79c63!4m6!3m5!1s0x47a6f9cd49586985:0xa208624a9bd59bee!8m2!3d51.3368225!4d12.3744574!16s%2Fg%2F11gjs9l5_l?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoASAFQAw%3D%3D">
                      Leipzig <FontAwesomeIcon icon={faMapLocation} />
                    </a>
                  </p>
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase"></p>
                  <div className="mt-6">
                    <p className="text-center">
                      {userName} <br />
                      c/o SimpliOffice / Thinkport GmbH
                      <br /> Markgrafenstraße 2
                      <br /> 04109 Leipzig
                    </p>
                  </div>
                </div>
              </div>
              <div className="max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 hover:cursor-pointer flex items-center justify-center">
                <div className="max-w-sm">
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase hover:cursor-pointer hover:text-green-500">
                    <a href="https://www.google.com/maps?rlz=1C5GCEM_enDE1033DE1033&sxsrf=APwXEdcls4CBX4bk06VmiZ2LPHTa-FjtUw:1685445549345&uact=5&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIHCAAQDRCABDIGCAAQHhANMggIABAFEB4QDTIICAAQBRAeEA0yCAgAEAUQHhANMggIABAIEB4QDTIICAAQCBAeEA0yCAgAEAgQHhANMggIABAIEB4QDTIICAAQCBAeEA06BwgjELADECc6CggAEEcQ1gQQsAM6CggAEIoFELADEEM6DQgAEOQCENYEELADGAE6EgguEIoFENQCEMgDELADEEMYAjoHCCMQigUQJzoHCAAQigUQQzoLCC4QxwEQrwEQywE6BQgAEIAEOgUIABDLAToICAAQigUQkQI6CwguEK8BEMcBEMsBOhkILhCvARDHARDLARCXBRDcBBDeBBDgBBgDOggIABAWEB4QDzoICAAQigUQhgM6BQghEKABSgQIQRgAUC9Y2yFgzyRoAXABeACAAdABiAGzB5IBBTYuMi4xmAEAoAEBwAEByAER2gEGCAEQARgJ2gEGCAIQARgI2gEGCAMQARgU&um=1&ie=UTF-8&daddr=Burchardstra%C3%9Fe+14,+20095+Hamburg&geocode=FSMXMQMd1p-YACljBT61z4-xRzFtXvhqFxagbA&f=d&saddr&iwstate1=dir:to&fb=1&gad=1&gclid=EAIaIQobChMInL_8p_ac_wIV2AGLCh3uOwswEBAYASABEgLTHfD_BwE&ei=Etx1ZI2xHJqRrATxhrfgCA">
                      Hamburg <FontAwesomeIcon icon={faMapLocation} />
                    </a>
                  </p>
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase"></p>
                  <div className="mt-6">
                    <p className="text-center">
                      Thinkport ({userName}) <br />
                      c/o Unicorn
                      <br /> Burchardstraße 14 <br /> 20095 Hamburg
                    </p>
                  </div>
                </div>
              </div>
              <div className="max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 hover:cursor-pointer flex items-center justify-center">
                <div className="max-w-sm">
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase hover:cursor-pointer hover:text-green-500">
                    <a href="https://www.google.com/maps/place/WeWork/@52.506369,13.373303,15z/data=!4m6!3m5!1s0x47a851596a5063d7:0x689b1fca81e7297c!8m2!3d52.506369!4d13.373303!16s%2Fg%2F11ghfds375">
                      Berlin <FontAwesomeIcon icon={faMapLocation} />
                    </a>
                  </p>
                  <p className="text-center text-sm font-semibold opacity-90">{t("berlinOfficeSearch")}</p>
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase"></p>
                  <div className="mt-6">
                    <p className="text-center">
                      {userName} <br />
                      c/o Unicorn Workspaces
                      <br /> Französische Straße 24 <br /> 10117 Berlin
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <span id="invoiceadressen">
            <div className="flex justify-center alert gradient-secondary new-border-radius" role="alert">
              <span className="block sm:inline">{t("invoicewarning")}</span>
            </div>

            <br />
            <div className="grid grid-cols-5 gap-4">
              <div></div>
              <div></div>
              <div className="max-w card-border-lg overflow-hidden card-bg-color p-30 md:p-6 hover:cursor-pointer flex items-center justify-center">
                <div className="max-w-sm">
                  <p className="text-center in-card-text font-bold text-xl mb-2 uppercase"></p>
                  <div>
                    <p className="text-center  in-card-text">
                      Thinkport GmbH
                      <br />
                      {userName}
                      <br /> Arnsburger Straße 74 <br /> 60385 Frankfurt (Main)
                    </p>
                    <CopyAddressComponent name={userName || "Dein Name"} />
                  </div>
                </div>
              </div>
            </div>

            <div></div>
            <div></div>
          </span>
        </>
      )}

      <Section id="collaboration" titleKey="collaboration" tilesFilter={categories.collaboration} />
      <Section id="bookings" titleKey="bookings" tilesFilter={categories.bookings} />
      <Section id="benefits" titleKey="benefits" tilesFilter={categories.benefits} />
    </div>
  );
}
